module.exports = "/assets/9be7feecd9bd630c212993d5318a736e.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/ZK.png
// module id = 3184
// module chunks = 0